// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"ContestsNavigation_layoutSwitch__HxQBp","paginationSwitch":"ContestsNavigation_paginationSwitch__H9ic-"};